import { PATH, PCodes } from '@common';

const SYSTEM_ADMIN = 'sa';
const TENANT_ADMIN = 'ta';
const NORMAL = 'na';

// 所有菜单定义
const ALL_MENUS = [
	{
		label: '首页',
		code: PCodes.DESK_INDEX,
		path: PATH.RISK_WARNING_MAIN
	},
	{
		label: '投保',
		code: PCodes.DESK_QUOTE,
		path: PATH.DESK_HOME
		//for: [SYSTEM_ADMIN]
	},
	{
		// 业务操作
		label: '查询',
		children: [
			{
				//报价单查询
				code: PCodes.DESK_QUERY_QUOTE,
				label: '报价单查询',
				path: PATH.QUERY_QUOTE 
				//for: [SYSTEM_ADMIN, TENANT_ADMIN, NORMAL]
			},
			{
				//保单查询
				code: PCodes.DESK_QUERY_POLICY,
				label: '保单查询',
				path: PATH.QUERY_POLICY
				//for: [SYSTEM_ADMIN, TENANT_ADMIN]
			},
			{
				//批改申请查询
				code: PCodes.DESK_QUERY_ENDO,
				label: '批改申请查询',
				path: PATH.QUERY_ENDO_APPLY
				//for: [SYSTEM_ADMIN, TENANT_ADMIN]
			}
		]
	},
	{
		label: '批改',
		code: PCodes.DESK_ENDO,
		path: PATH.ENDO,
		for: [NORMAL]
	},
	{
		label: '理赔',
		children: [
			{
				//理赔服务
				code: PCodes.DESK_CLAIM_SERVICE,
				label: '理赔服务',
				path: PATH.CLAIM_SERVICE,
				for: [NORMAL]
			}
		]
	},
	{
		// 系统管理
		label: '我的',
		children: [
			{
				// 修改密码
				code: PCodes.DESK_MODIFY_PWD,
				label: '修改密码',
				path: PATH.DESK_ACCOUNT_CHANGE_PWD
				//for: [TENANT_ADMIN, SYSTEM_ADMIN]
			},
			{
				//修改企业信息
				code: PCodes.DESK_MODIFY_ACCOUNT,
				label: '修改企业信息',
				path: PATH.DESK_ACCOUNT_EDIT,
				for: [NORMAL]
			}
			// {
			// 	//退出登录
			// 	code: PCodes.DESK_EXIT,
			// 	label: '退出登录',
			// 	path: PATH.DESK_ACCOUNT_CHANGE_PWD,
			// 	always: true
			// }
		]
	}
];
export { SYSTEM_ADMIN, TENANT_ADMIN, NORMAL, ALL_MENUS };
